import React from "react";

export const FileDeliveryIcon = () => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="41" height="41" rx="8.5" fill="#222222" />
      <rect x="0.5" y="0.5" width="41" height="41" rx="8.5" stroke="black" />
      <circle cx="21" cy="21" r="16" fill="url(#paint0_linear_19993_148842)" />
      <path
        d="M29.0297 15.7664C29.1703 15.907 29.25 16.0969 29.25 16.2961V30.75C29.25 31.1648 28.9148 31.5 28.5 31.5H13.5C13.0852 31.5 12.75 31.1648 12.75 30.75V11.25C12.75 10.8352 13.0852 10.5 13.5 10.5H23.4539C23.6531 10.5 23.8453 10.5797 23.9859 10.7203L29.0297 15.7664ZM27.5203 16.6406L23.1094 12.2297V16.6406H27.5203Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_19993_148842"
          x1="37"
          y1="21"
          x2="5"
          y2="21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D0D0D" />
          <stop offset="1" stopColor="#2F2F2F" />
        </linearGradient>
      </defs>
    </svg>
  );
};
